import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function MachinePayment() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [bookingList, setBookingList] = useState([]);
    const [formData, setFormData] = useState({
        booking: "",
        amount: "",
        payment_date: "",
        payment_mode: "CASH",
        transaction_reference: "",
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    const paymentModeList = [{
        id: "ONLINE", name: "Online",
    }, {
        id: "OFFLINE", name: "Offline",
    }, {
        id: "UPI", name: "UPI",
    }, {
        id: "BANK", name: "Bank",
    }, {
        id: "CASH", name: "Cash",
    },];
    useEffect(() => {
        getMachineBooking();
        getMachinePayment();
    }, []);
    const getMachineBooking = () => {
        axios
            .get(baseUrl + "machine-booking/")
            .then((res) => {
                setBookingList(res.data);
            });
    };
    const getMachinePayment = () => {
        setLoading(true);
        axios
            .get(baseUrl + "machine-payment/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Machine Payments.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value,
        });
    };
    const clearForm = () => {
        setFormData({
            booking: "",
            amount: "",
            payment_date: "",
            payment_mode: "CASH",
            transaction_reference: "",
            remarks: "",
            status: 1,
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveMachinePayment = () => {
        const data = new FormData();
        data.append("booking", formData.booking);
        data.append("amount", formData.amount);
        data.append("payment_date", formData.payment_date);
        data.append("payment_mode", formData.payment_mode);
        data.append("transaction_reference", formData.transaction_reference);
        data.append("remarks", formData.remarks);
        data.append("status", formData.status);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "machine-payment/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Success", text: "Machine Payment saved successfully.",
                });
                clearForm();
                getMachinePayment();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Machine Payment.",
                });
            });
    };
    const deleteMachinePayment = (id) => {
        Swal.fire({
            title: "Delete Machine Payment?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(`machine-payment/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Machine Payment deleted successfully.",
                        });
                        getMachinePayment();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Machine Payment.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "booking_no",
        headerName: "Booking",
        width: 180,
        renderCell: (params) => params.row.booking?.machine.machine_name || ""
    }, {
        field: "amount", headerName: "Amount", width: 120,
    }, {
        field: "payment_date", headerName: "Payment Date", width: 140,
    }, {
        field: "payment_mode", headerName: "Payment Mode", width: 140,
    }, {
        field: "transaction_reference", headerName: "Reference", flex: 1,
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value === 1 ? "Active" : "Inactive",
    },];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Machine Payment
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4 mb-3">

                            <label>Machine Booking</label>

                            <select
                                className="form-select"
                                name="booking"
                                value={formData.booking}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Booking
                                </option>

                                {bookingList.map((item) => (<option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.machine.machine_name}
                                    </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Amount</label>

                            <input
                                type="number"
                                className="form-control"
                                name="amount"
                                value={formData.amount}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Payment Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="payment_date"
                                value={formData.payment_date}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Payment Mode</label>

                            <select
                                className="form-select"
                                name="payment_mode"
                                value={formData.payment_mode}
                                onChange={handleChange}
                            >

                                {paymentModeList.map((item) => (<option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>))}

                            </select>

                        </div>

                        <div className="col-md-8 mb-3">

                            <label>Transaction Reference</label>

                            <input
                                type="text"
                                className="form-control"
                                name="transaction_reference"
                                value={formData.transaction_reference}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-10 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="2"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </select>

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveMachinePayment}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Machine Payment List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}

                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>);
}
export default MachinePayment;